import { render, staticRenderFns } from "./toGuildLeader.vue?vue&type=template&id=05ae5476&scoped=true"
import script from "./toGuildLeader.vue?vue&type=script&lang=js"
export * from "./toGuildLeader.vue?vue&type=script&lang=js"
import style0 from "./toGuildLeader.vue?vue&type=style&index=0&id=05ae5476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae5476",
  null
  
)

export default component.exports